export const ZODIAC_SIGNS = {
  capricorn: 'Capricorn',
  aquarius: 'Aquarius',
  pisces: 'Pisces',
  aries: 'Aries',
  taurus: 'Taurus',
  gemini: 'Gemini',
  cancer: 'Cancer',
  leo: 'Leo',
  virgo: 'Virgo',
  libra: 'Libra',
  scorpio: 'Scorpio',
  sagittarius: 'Sagittarius'
}

export const getZodiac = (date: Date) => {
  if (!date) return null

  const zodiac = [ '', ...Object.keys(ZODIAC_SIGNS) ]
  const last_day =[0, 19, 18, 20, 20, 21, 21, 22, 22, 21, 22, 21, 20, 19]

  const sign = (date.getDate() > last_day[date.getMonth() + 1] ? zodiac[date.getMonth() + 1 * 1 + 1] : zodiac[date.getMonth() + 1]) as keyof typeof ZODIAC_SIGNS

  return sign ?? null
}